import signInMiddleware from './signIn';
import signUpMiddleware from './signUp';
import socialLogin from './socialLogin';

export default [signInMiddleware, signUpMiddleware, socialLogin];
